import React, { useEffect, useState } from 'react';
import { ReportsDataService } from '../../Services/ReportsDataService';
import PowerBIReport from '../../Components/PowerBIReport/PowerBIReport';
import { models } from 'powerbi-client';
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '../../authConfig';
import { PageLayout2 } from '../../Components/PageLayout/PageLayout2';
import { Col, Container, Row, Dropdown, ButtonGroup, Button } from 'react-bootstrap';
import './ReportsPage.css';
import { ReportsConfigurationDataService } from '../../Services/ReportsConfigurationDataService'; // For saved report selections

const WorkspacesComponent = () => {
    const { instance, accounts, inProgress } = useMsal();
    const [reports, setReports] = useState([]);
    const [currentReport, setCurrentReport] = useState(null);
    const [visibleReports, setVisibleReports] = useState([]);
    const [dropdownReports, setDropdownReports] = useState([]);

    useEffect(() => {
        fetchSavedReportSelections();
    }, []);

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [reports]);

    // Fetch the saved/selected reports from the database
    const fetchSavedReportSelections = async () => {
        try {
            const token = await instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0]
            });
            const savedReports = await ReportsConfigurationDataService.getSelectedReports(token.accessToken);
            setReports(savedReports); // No need to filter since these are already selected reports
            if(savedReports.length > 0) {
                const firstReport = savedReports[0];
                handleSelectReport(firstReport.reportId, firstReport.workspaceId);
            }
        } catch (error) {
            console.error('Error fetching saved report selections:', error);
        }
    };

    // Handle report selection
    const handleSelectReport = async (reportId, workspaceId) => {
        try {
            const data = await ReportsDataService.getReportEmbeddingDetails(workspaceId, reportId);
            setCurrentReport(data);
        } catch (error) {
            console.error('Error fetching report embedding details:', error);
        }
    };

    const handleResize = () => {
        const containerWidth = document.getElementById('reports-container')?.offsetWidth;
        const buttonWidth = 150;
        const maxVisibleButtons = Math.floor(containerWidth / buttonWidth);

        setVisibleReports(reports.slice(0, maxVisibleButtons - 1));
        setDropdownReports(reports.slice(maxVisibleButtons - 1));
    };

    return (
        <Container fluid className='d-flex flex-column'>
            {reports.length === 0 ? (
                <p>No reports available at the moment. System administrator must configure the report selections.</p>
            ) : (
                <>
                    <div id="reports-container" className="d-flex align-items-center justify-content-start mb-3">
                        {visibleReports.map((object) => (
                            <Button
                                key={object.ReportId}
                                className={`mx-1 text-dark report-button ${currentReport?.EmbedReport.ReportId == object.reportId ? 'active' : ''}`}
                                onClick={() => handleSelectReport(object.reportId, object.workspaceId)}
                                variant='light-gray'
                            >
                                {object.reportName}
                            </Button>
                        ))}
                        {dropdownReports.length > 0 && (
                            <Dropdown as={ButtonGroup} className="mx-1" align="end">
                                <Dropdown.Toggle variant='light-gray' className='text-dark'>
                                    View More
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {dropdownReports.map((object) => (
                                        <Dropdown.Item
                                            key={object.reportId}
                                            onClick={() => handleSelectReport(object.reportId, object.workspaceId)}
                                        >
                                            {object.reportName}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                    </div>
                </>
            )}
    
            {!currentReport && (
                <div className="text-center mt-3">
                    {reports.length > 0 ? (
                        <p>Please select a report to load.</p>
                    ) : (
                        <p>No report to display.</p>
                    )}
                </div>
            )}
            <PowerBIReport
                reportId={currentReport?.EmbedReport.ReportId}
                embedUrl={currentReport?.EmbedReport.EmbedUrl}
                accessToken={currentReport?.EmbedToken.Token}
                tokenType={models.TokenType.Embed}
            />
        </Container>
    );
    
};

const ReportsPage = () => {
    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <PageLayout2 title="Reports">
                <WorkspacesComponent />
            </PageLayout2>
        </MsalAuthenticationTemplate>
    )
}

export default ReportsPage;
